import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts'

const EchartsDemo = props => {
  const chartRef = useRef(null)
  let { styleProps = { height: '300px' } } = props
  useEffect(() => {
    const chartDom = chartRef.current
    const myChart = echarts.init(chartDom)
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      // grid: {
      //   left: '3%',
      //   right: '4%',
      //   bottom: '3%',
      //   containLabel: true
      // },
      // xAxis: [
      //   {
      //     type: 'category',
      //     axisTick: {
      //       alignWithLabel: true
      //     }
      //   }
      // ],
      // yAxis: [
      //   {
      //     type: 'value'
      //   }
      // ],
      series: [],
      ...props.echartProps
    }
    myChart.setOption(option)
    return () => {
      // 组件卸载时执行的清理函数
      // 此函数用于释放 ECharts 实例占用的资源，避免内存泄漏
      // 确保在组件卸载时，ECharts 图表被正确销毁
      myChart.dispose()
    }
  }, [props])

  return <div ref={chartRef} style={{ width: '100%', height: '100%', ...styleProps }} />
}

export default EchartsDemo
